module.exports = __webpack_public_path__ + "static/media/oops.913e0bab.png";